import { Theme as DefaultTheme, makeStyles } from '@material-ui/core';
import { Styles } from '@material-ui/core/styles/withStyles';

type ClassNameMap<ClassKey extends string = string> = Record<ClassKey, string>;
/**
 * returns a function that returns classes that only apply to print
 *  @see {@link makeStyles} */
function makePrintStyles<Theme = DefaultTheme, ClassKey extends string = string>(
  styles: Styles<Theme, {}, ClassKey>
): () => ClassNameMap<ClassKey> {
  const buildClassKeys = () => {
    const result = Object.entries(styles).reduce((acc, [key, values]) => {
      return {
        ...acc,
        [key]: {
          // eslint-disable-next-line
          ['@media print']: values
        }
      };
    }, {});

    return result;
  };

  return makeStyles(() => buildClassKeys()) as any;
}

export default makePrintStyles;
